import { Injectable, inject } from '@angular/core';

import { HttpClientPort } from '../../core/http/http-client.port';
import { Language } from '../../domain/entities/language';
import { Translations } from '../../domain/entities/translations';
import { TranslationRepository } from '../../domain/repositories/translation.repository';
import { translationsAsset } from '../http/i18n-assets';
import { toTranslations } from '../mappers/translations.mapper';

@Injectable()
export class AssetTranslationRepository extends TranslationRepository {
  private readonly http = inject(HttpClientPort);

  async findAll(language: Language): Promise<Translations> {
    const payload = await this.http.getAbsolute(translationsAsset(language));
    return toTranslations(payload);
  }
}
